import { render, staticRenderFns } from "./Продажы по группам0.vue?vue&type=template&id=6b5f77a8&scoped=true"
import script from "./Продажы по группам0.vue?vue&type=script&lang=js"
export * from "./Продажы по группам0.vue?vue&type=script&lang=js"
import style0 from "./Продажы по группам0.vue?vue&type=style&index=0&id=6b5f77a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f77a8",
  null
  
)

export default component.exports